const metaAuth = {
  auth: [1],
};
const obj = {
  path: "/stystem",
  name: "stystem",
  meta: metaAuth,
  component: (resolve) => require(["@/views/Home/index.vue"], resolve),
  children: [
    {
      name: "stystem/invite",
      path: "/stystem/invite",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/invite/index.vue"], resolve),
    },
    {
      name: "stystem/main",
      path: "/stystem/main",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/main/index.vue"], resolve),
    },
    {
      name: "stystem/listWinners",
      path: "/stystem/listWinners",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/listWinners/index.vue"], resolve),
    },
    {
      name: "stystem/winLucky",
      path: "/stystem/winLucky",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/winLucky/optimize.vue"], resolve),
    },
    {
      name: "stystem/redemptionDraw",
      path: "/stystem/redemptionDraw",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/redemptionDraw/index.vue"], resolve),
    },
    {
      name: "stystem/earings",
      path: "/stystem/earings",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/earings/index.vue"], resolve),
    },
    {
      name: "stystem/earings/detail",
      path: "/stystem/earings/detail",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/earings/detail/index.vue"], resolve),
    },
    {
      name: "stystem/earings/detail/particulars",
      path: "/stystem/earings/detail/particulars",
      meta: metaAuth,
      component: (resolve) =>
        require([
          "@/views/stystem/earings/detail/components/inviteDetail/components/particulars/index.vue",
        ], resolve),
    },
    {
      name: "stystem/lottery",
      path: "/stystem/lottery",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/lottery/index.vue"], resolve),
    },
    {
      name: "stystem/lottery/lotteryDetail",
      path: "/stystem/lottery/lotteryDetail",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/lottery/lotteryDetail/index.vue"], resolve),
    },
    {
      name: "stystem/lottery/lotteryParticulars",
      path: "/stystem/lottery/lotteryParticulars",
      meta: metaAuth,
      component: (resolve) =>
        require([
          "@/views/stystem/lottery/lotteryParticulars/index.vue",
        ], resolve),
    },
    {
      name: "stystem/newcomerRecommend",
      path: "/stystem/newcomerRecommend",
      meta: metaAuth,
      component: (resolve) =>
        require(["@/views/stystem/newcomerRecommend/index.vue"], resolve),
    },
  ],
};
export default obj;
